import { useHistory } from 'react-router-dom';
import { t } from 'i18next';

import Button from 'components/Button/Button';
import { ReactComponent as Failed } from 'assets/icons/failed.svg';
import { ReactComponent as Refresh } from 'assets/icons/refresh.svg';

import './QuizResult.scoped.scss';

const QuizStarter = () => {
  const history = useHistory();
  const quizResult = JSON.parse(window.localStorage.getItem('quizResult'));
  const resultInPercentage = parseInt(
    ((quizResult.correctAnswers / quizResult.totalAnswers) * 100).toFixed(2),
    10
  );

  return (
    <div className="quizresult-container">
      <h3>
        {t('study:results')}
        <span style={{ fontSize: '30px', display: resultInPercentage >= 50 ? '' : 'none' }}>
          🎉
        </span>
      </h3>

      <table className={resultInPercentage >= 50 ? 'success' : 'failed'}>
        <tr>
          <th>
            {resultInPercentage >= 50 ? (
              <span>{t('study:success')}</span>
            ) : (
              <span>
                {t('study:failed')} &nbsp; <Failed />
              </span>
            )}
          </th>
          <th colSpan={2}>
            <span>
              <Refresh /> &nbsp; {t('study:2_attempts_left')}
            </span>
          </th>
        </tr>
        <tr>
          <td>{t('study:score')}</td>
          <td>
            {quizResult.correctAnswers} / {quizResult.totalAnswers}
          </td>
          <td>{`${resultInPercentage}%`}</td>
        </tr>
        <tr>
          <td>{t('study:validation_by_teacher')}</td>
          <td colSpan={2}>{`${quizResult.totalOpenAnswers} ${t('study:question')}`}</td>
        </tr>
        <tr>
          <td>{t('study:met_minimum_requirements')}</td>
          <td colSpan={2}>{resultInPercentage >= 50 ? t('study:yes') : t('study:no')}</td>
        </tr>
      </table>

      <div className="controller">
        <Button
          onClick={() => undefined}
          round
          style={{
            backgroundColor: 'white',
            border: '2px solid #5CD79E',
            width: '130px',
            color: '#000',
            margin: '0px 30px',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          {t('study:finish')}
        </Button>
        <Button
          onClick={() => history.push('/quiz')}
          round
          style={{
            backgroundColor: '#5CD79E',
            border: '2px solid #5CD79E',
            color: '#fff',
            margin: '0px 30px',
            fontSize: '14px',
            fontWeight: 500,
            padding: '0 20px',
          }}
        >
          {t('study:take_quiz_again')}
        </Button>
      </div>
    </div>
  );
};

export default QuizStarter;
